
import { StationModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { stationsStore } from '@/libs/stations/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import StationDialog from '../components/StationDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        StationDialog,
    },
})
export default class Stations extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('stations.title'), value: 'name', align: 'left', sortable: false },
            { text: this.$i18n.t('stations.workplace'), value: 'workplace.name', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: StationDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return stationsStore.useGetter(CrudGetter.Pending);
    }

    get locations(): StationModel[] {
        return [...stationsStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...stationsStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        stationsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<StationModel>({ field: 'name', index: 1, order: 'asc' }, this.getFilters());
    }

    open(item: StationModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }
}
